module.exports = __webpack_public_path__ + "media/images/chevron-solid-down-195255d8f0abe9d8a7de1ac7273f8379.svg";